import React, { useEffect, useState, useRef, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useBusiness, useTitle } from '../Hooks';
import { Table, Image, Button, Header, Input, Message, Field, Toast, Groupper} from 'react-frontier';
import { bindFormChange, bindClick } from '@tempu/components/Util';
import { Modal } from '../components';
import { formatAddress } from '../Util';
import { Business, EditBusinessData, TaxInfo, Location } from '../Classes';
import { Dropdown } from 'semantic-ui-react';
import API, { CDN_URL } from '../API';
import BusinessAccess from '../BusinessAccess';
import moment from 'moment';
import Validator from '@tempu/components/Validator';

const regimenList = [
   { text: 'Sueldos y Salarios e Ingresos Asimilados a Salarios', value: '605' },
   { text: 'Arrendamiento', value: '606' },
   { text: 'Demás ingresos', value: '608' },
   { text: 'Ingresos por Dividendos (socios y accionistas)', value: '611' },
   { text: 'Personas Físicas con Actividades Empresariales y Profesionales', value: '612' },
   { text: 'Ingresos por intereses', value: '614' },
   { text: 'Régimen de los ingresos por obtención de premios', value: '615' },
   { text: 'Sin obligaciones fiscales', value: '616' },
   { text: 'Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras', value: '622' },
   { text: 'Incorporación Fiscal', value: '621' },
   { text: 'De los Régimenes Fiscales Preferentes y de las Empresas Multinacionales', value: '629' },
   { text: 'Enajenación de acciones en bolsa de valores', value: '630' },
   { text: 'General de ley personas morales', value: '601' },
   { text: 'Régimen Simplificado de Confianza', value: '626' }
]

const cfdiList = [
   { text: 'Adquisición de mercancías', value: 'G01' },
   { text: 'Devoluciones, descuentos o bonificaciones', value: 'G02' },
   { text: 'Gastos en general', value: 'G03' },
   { text: 'Construcciones', value: 'I01' },
   { text: 'Mobiliario y equipo de oficina por inversiones', value: 'I02' },
   { text: 'Equipo de transporte', value: 'I03' },
   { text: 'Equipo de cómputo y accesorios', value: 'I04' },
   { text: 'Dados, troqueles, moldes, matrices y herramental', value: 'I05' },
   { text: 'Comunicaciones telefónicas', value: 'I06' },
   { text: 'Comunicaciones satelitales', value: 'I07' },
   { text: 'Otra maquinaria y equipo', value: 'I08' },
   { text: 'Honorarios médicos, dentales y gastos hospitalarios', value: 'D01' },
   { text: 'Gastos médicos por incapacidad o discapacidad', value: 'D02' },
   { text: 'Gastos funerales', value: 'D03' },
   { text: 'Donativos', value: 'D04' },
   { text: 'Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación)', value: 'D05' },
   { text: 'Aportaciones voluntarias al SAR', value: 'D06' },
   { text: 'Primas por seguros de gastos médicos', value: 'D07' },
   { text: 'Gastos de transportación escolar obligatoria', value: 'D08' },
   { text: 'Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones', value: 'D09' },
   { text: 'Pagos por servicios educativos (colegiaturas)', value: 'D10' },
   { text: 'Pagos', value: 'CP01' },
   { text: 'Nómina', value: 'CN01' },    
   { text: 'Sin Efectos Fiscales', value: 'S01' },              
]

var initateForm: TaxInfo = {
   tax_id: null,
	legal_name: null,
	rfc: null,
	email: null,
	deleted: false,
	regimen: null,
	use_cfdi: null,
	location_id: null,
	date_created: null,
	location:{
		state: null,
		street: null,
		zipcode: null,
		city: null,
		phone: null,
		country: null,
		comments: null,
		exterior_number: null,
		interior_number: null,
		name: null,
		neighborhood: null,
	}
}

enum Modals{
	INFO = 1,
	TAX_DATA = 2
}

var BusinessSettings = ()=>{
	var params = useParams<{ id: string }>();
	var business_id = parseInt(params?.id);
	var { setTitle } = useTitle();
	var { hasAccess } = useBusiness(business_id);
	var [loadError, setLoadError] = useState<string>(null);
	var [business, setBusiness] = useState<Business>(null);
	var [shownModal, setShownModal] = useState<Modals>(null);
	var [editInfoForm, setEditInfoForm] = useState<EditBusinessData>(null);
	var [modalPrompts, setModalPrompts] = useState<string[]>(null);
	var imageInputRef = useRef<HTMLInputElement>(null);
	var [addingImage, setAddingImage] = useState<boolean>(false);
	var [taxDataForm, setTaxDataForm] = useState<TaxInfo>(initateForm);
	var [location, setLocation] = useState<Location>(initateForm.location)

	useEffect(()=>{
		if(!business_id || Number.isNaN(business_id)) return;
		if(!hasAccess(BusinessAccess.POSTINGS.VIEW_POSTINGS)) return;

		API.getBusiness(business_id, true).then(res=>{
			if(res.error) return setLoadError(res.message);
			setTitle(res.data.business_name);
			setBusiness(res.data);
		}).catch(err=>{
			return setLoadError('Hubo un error inesperado cargando la información del negocio. (LCL-1)');
		})
	}, []);
	
	var business_image_refresh = useMemo(()=>{
		return moment().unix();
	}, [business, addingImage]);

	var openEditDataModal = ()=>{
		setEditInfoForm({
			business_name: business.business_name,
			website: business.website,
			about: business.about
		})
		setShownModal(Modals.INFO);
	};

	var editInfo = async(setLoading: (l: boolean)=>void)=>{
		var { valid, prompts } = Validator(editInfoForm, {  
			business_name: [{
				rule: 'minLength', params: [3], label: 'Nombre de negocio'
			}],
		});
		setModalPrompts(prompts);
		if(!valid) return;
		setLoading(true);
		API.editBusiness(business_id, editInfoForm).then(res=>{
			if(res.error) return setModalPrompts([res.message]);
			Toast.success('Negocio actualizado!');
			var b = {...business};
			b.business_name = editInfoForm.business_name;
			b.website = editInfoForm.website;
			b.about = editInfoForm.about;
			setBusiness(b);
			setTitle(b.business_name);
			setEditInfoForm(null);
			setShownModal(null);
		}).catch(err=>{
			setModalPrompts(['Hubo un error al editar el negocio. (BEE-1)']);
		}).finally(()=>{
			setLoading(false);
		});
	};

	var addImage = ()=>{
		imageInputRef.current?.click();
	}

	var handleImage = (ev: React.ChangeEvent<HTMLInputElement>)=>{
		if(!ev.target.files || ev.target.files.length==0) return;
		if(ev.target.files.length>1) return Toast.error("Favor de solo seleccionar 1 archivo.");
		var image = ev.target.files[0];
		if(image.size>(2.5*1024*1024)) return Toast.error('La imagen no puede pesar mas de 2.5MB.');

		setAddingImage(true);
		var tx = Toast.show('Subiendo imágen del negocio...', { loading: true });
		API.addBusinessImage(business.business_id, image).then(res=>{
			if(res.error) return Toast.error(res.message);
			Toast.success('Se ha cambiado la imagen del negocio');
		}).catch(err=>{
			return Toast.error('Hubo un error subiendo la imagen del negocio. (LCL-1)');
		}).finally(()=>{
			Toast.dismiss(tx);
			setAddingImage(false);
		});
	}

	var onEditInfo = bindFormChange(editInfoForm, setEditInfoForm);
	var onEditTaxData = bindFormChange(taxDataForm, setTaxDataForm);
	var onEditTaxDataLocation = bindFormChange(location, setLocation);

	if(!hasAccess(BusinessAccess.ADMIN.EDIT_BUSINESS_INFO) && !hasAccess(BusinessAccess.ADMIN.EDIT_BUSINESS_IMAGE)){
		return <Header text='Sin acceso' subtext='No tienes acceso a esta página' />
	}

	if(loadError){
		return <Header text='Error' subtext={loadError} />
	}

	if (!business) {
		return <Header loading text='Cargando datos' />;
	}

	const NoInfo = <span style={{ fontStyle: 'italic', color: 'gray' }}>Sin información</span>
	
	return <div className='tp business-settings-screen'>
		<div className='business-info'>
			<div className="image">
				<Image src={`${CDN_URL}/business/${business.business_id}/large.webp?t=${business_image_refresh}`} fallbackComponent={(
					<i className='image icon' />
				)} />
				<input type="file" style={{ display: 'none' }} ref={imageInputRef} accept="image/*" onChange={handleImage}/>
				{hasAccess(BusinessAccess.ADMIN.EDIT_BUSINESS_IMAGE) && (
					<Button iconName={'pencil'} iconStyle={{ marginRight: 5 }} size='tiny' loading={addingImage} text='Cambiar imágen' style={{ marginTop: 5, lineHeight: '16px', width: 150 }} onClick={addImage}/>
				)}
			</div>
			<Table
				details
				striped
				title='Datos de negocio'
				className='info'
				button={
					<Button text='Editar' iconName='pen' size='tiny' onClick={openEditDataModal} /> 
				}
				data={[
					['ID', business.business_id],
					['Nombre', business.business_name],
					['Creado', moment.unix(business.date_created).format('DD/MMM/YY HH:mm')],
					['Website', business.website || NoInfo],
					// ['about', business.about || NoInfo],
				]}
			>
			</Table>
		</div>
		{business.tax_data ? (
			<Table
				details
				striped
				className='tax'
				title='Datos Fiscales'
				emptyText='No se encontraron registros.'
				button={
					<Button text='Editar' iconName='pen' size='tiny' onClick={bindClick(setShownModal, Modals.TAX_DATA)} /> 
				}
				data={[
					['Razón social', business.tax_data.legal_name],
					['RFC', business.tax_data.rfc],
					['Regimén', regimenList.find(r => r.value === business.tax_data.regimen)?.text],
					['CFDI', cfdiList.find(c => c.value === business.tax_data.use_cfdi)?.text],
					['Correo electronico', business.tax_data.email],
					['Telefono', business.tax_data.location.phone],
					['Dirección', formatAddress(business.tax_data.location)],
				]}
			/>
		) : (
			<Groupper title={'Datos fiscales'} style={{ marginTop: 10 }}>
				<Header text={'Sin datos fiscales'} subtext={'Es necesario ingresar los datos fiscales del negocio'} iconName='exclamation-triangle' actions={(
					<Button text='Agregar datos' iconName={'pen'} onClick={bindClick(setShownModal, Modals.TAX_DATA)} />
				)} />
			</Groupper>
		)}
		{hasAccess(BusinessAccess.ADMIN.EDIT_BUSINESS_INFO) && (
			<Modal open={shownModal===Modals.INFO} onClose={bindClick(setShownModal)} size='tiny'>
				<Modal.Header>Modificar información</Modal.Header>
				{editInfoForm && <Modal.Content>
					<Input label='Nombre de negocio' placeholder='Ingresa el nombre del negocio' value={editInfoForm.business_name} onChange={onEditInfo('business_name')}/>
					<Input label='Website' placeholder='Ingresa el website del negocio' value={editInfoForm.website} onChange={onEditInfo('website')}/>
					<Input label='About' placeholder='Ingresa la información del negocio' textarea value={editInfoForm.about} onChange={onEditInfo('about')}/>
					<Message type="error" list={modalPrompts} />
				</Modal.Content>}
				<Modal.Actions>
					<Button text='Cerrar' onClick={bindClick(setShownModal)} />
					<Button text='Guardar' color='black' onClick={editInfo}/>
				</Modal.Actions>
			</Modal>
		)}
		{hasAccess(BusinessAccess.ADMIN.EDIT_BUSINESS_INFO) && (
			<Modal open={shownModal===Modals.TAX_DATA} onClose={bindClick(setShownModal)} size='tiny'>
				<Modal.Header>Modifcar datos fiscales</Modal.Header>
				{taxDataForm && <Modal.Content>
					<Field amount={2}>
						<Input label='Razón social' value={taxDataForm.legal_name} onChange={onEditTaxData('legal_name')}/>
						<Input label='Correo electrónico' value={taxDataForm.email} onChange={onEditTaxData('email')}/>
					</Field>
					<Input label='RFC' value={taxDataForm.rfc} onChange={onEditTaxData('rfc')}/>
					<Field label='Régimen'>
						<Dropdown
							fluid
							selection
							placeholder='Régimen'
							options={regimenList.map(r => ({
								key: r.value,
								text: r.text,
								value: r.value
							}))}
							style={{marginBottom: 10}}
							value={taxDataForm.regimen}
							onChange={onEditTaxData('regimen', true)}
						/>
					</Field>
					<Field label='CFDI'>
						<Dropdown
							fluid
							selection
							placeholder='CFDI'
							options={cfdiList.map(c => ({
								key: c.value,
								text: c.text,
								value: c.value
							}))}
							style={{marginBottom: 10}}
							value={taxDataForm.use_cfdi}
							onChange={onEditTaxData('use_cfdi', true)}
						/>
					</Field>
					<Field>
						<Input label='Calle' value={location.street} onChange={onEditTaxDataLocation('street')}/>
					</Field>
					<Field amount={2}>
						<Input label='Numero exterior' value={location.exterior_number} onChange={onEditTaxDataLocation('exterior_number')}/>
						<Input label='Numero inferior' value={location.interior_number} onChange={onEditTaxDataLocation('interior_number')}/>
					</Field>
					<Field amount={2}>
						<Input label='Colonia' value={location.neighborhood} onChange={onEditTaxDataLocation('neighborhood')}/>
						<Input label='Ciudad' value={location.city} onChange={onEditTaxDataLocation('city')}/>
					</Field>
					<Field amount={2}>
						<Input label='Estado' value={location.state} onChange={onEditTaxDataLocation('state')}/>
						<Input label='Código postal' value={location.zipcode} onChange={onEditTaxDataLocation('zipcode')}/>
					</Field>
					<Message type="error" list={modalPrompts} />
				</Modal.Content>}
				<Modal.Actions>
					<Button text='Cerrar' onClick={bindClick(setShownModal)} />
					<Button text='Guardar' color='black' />
				</Modal.Actions>
			</Modal>
		)}
	</div>
}

export default BusinessSettings;